import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=e5a0c1ae&scoped=true&"
import script from "./phone.vue?vue&type=script&lang=js&"
export * from "./phone.vue?vue&type=script&lang=js&"
import style0 from "./phone.vue?vue&type=style&index=0&id=e5a0c1ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a0c1ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5a0c1ae')) {
      api.createRecord('e5a0c1ae', component.options)
    } else {
      api.reload('e5a0c1ae', component.options)
    }
    module.hot.accept("./phone.vue?vue&type=template&id=e5a0c1ae&scoped=true&", function () {
      api.rerender('e5a0c1ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myInformation/phone.vue"
export default component.exports